module.exports = __webpack_public_path__ + "img/remove.2bfb0936.png";